var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyPillarGrowth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#strategy-pillar-growth_svg__clip0_7917_382798)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 21v1l-8 2.5-7-1.94V24H2V13h7.97l6.16 2.3A2.89 2.89 0 0118 18h2c1.66 0 3 1.34 3 3zM6 22v-7H4v7h2zm14.9-1.43c-.16-.33-.51-.57-.9-.57h-5.35c-.54 0-1.07-.08-1.58-.25l-2.38-.79.63-1.9 2.38.79c.3.1 2.3.15 2.3.15 0-.37-.23-.7-.57-.83L9.61 15H8v5.5l6.97 1.91 5.93-1.84zM13 12.131l-2-.746V8.4S10.8 5 8 5c0 0 1.5.8 1.9 3.7-.4.1-.8.1-1.1.1C4.2 8.8 4 2.1 4 2.1S4.6 2 5.5 2c1.9 0 5 .4 5.9 3.1C11.9.6 17 0 19.5 0c.9 0 1.5.1 1.5.1s0 9-6.3 9H14c0-2 2-5 2-5-3 1-3 4.9-3 4.9v3.131z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "strategy-pillar-growth_svg__clip0_7917_382798"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgStrategyPillarGrowth;